import { AbstractFormControl } from "./form-control";

export class TextareaControl extends AbstractFormControl<HTMLTextAreaElement> {

    getName(): string {
        return this.element.name;
    }

    getValue() {
        return this.element.value;
    }

    setValue(value: any): void {
        // Needed for data list bulk edit where items are represent as an array of strings for editing
        if (Array.isArray(value)) {
            this.element.value = value.map(item => `${item}`).join('\n');
            return;
        }

        this.element.value = value ?? '';
    }

    /** @override */
    select(): void {
        this.element.select();
    }

    setEnabled(enabled: boolean): void {
        this.element.disabled = !enabled;
    }

    insertTextAtCaret(text: string) {
        this.element.setRangeText(text, this.element.selectionStart, this.element.selectionEnd);
    }
}
